import { InMemoryCache, ApolloClient, resetApolloClientSingletons, SSRMultipartLink as SSRMultipartLink$1, DebounceMultipartResponsesLink as DebounceMultipartResponsesLink$1, RemoveMultipartDirectivesLink as RemoveMultipartDirectivesLink$1, ApolloNextAppProvider as ApolloNextAppProvider$1 } from '@apollo/experimental-nextjs-app-support';
import { useBackgroundQuery as useBackgroundQuery$1, useFragment as useFragment$1, useQuery as useQuery$1, useReadQuery as useReadQuery$1, useSuspenseQuery as useSuspenseQuery$1 } from '@apollo/client/index.js';

// src/ssr/index.ts
var NextSSRInMemoryCache = InMemoryCache;
var NextSSRApolloClient = ApolloClient;
var resetNextSSRApolloSingletons = resetApolloClientSingletons;
var SSRMultipartLink = SSRMultipartLink$1;
var DebounceMultipartResponsesLink = DebounceMultipartResponsesLink$1;
var RemoveMultipartDirectivesLink = RemoveMultipartDirectivesLink$1;
var ApolloNextAppProvider = ApolloNextAppProvider$1;
var useBackgroundQuery = useBackgroundQuery$1;
var useFragment = useFragment$1;
var useQuery = useQuery$1;
var useReadQuery = useReadQuery$1;
var useSuspenseQuery = useSuspenseQuery$1;
const built_for_browser = true;

export { ApolloNextAppProvider, DebounceMultipartResponsesLink, NextSSRApolloClient, NextSSRInMemoryCache, RemoveMultipartDirectivesLink, SSRMultipartLink, built_for_browser, resetNextSSRApolloSingletons, useBackgroundQuery, useFragment, useQuery, useReadQuery, useSuspenseQuery };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.browser.js.map